import React from 'react';
import { inserterOptions } from '../../../../consts/inserterOptions';
import { TinyMCE } from '../../../../../../../../../components/adapters/inputs/TinyMCE';
export const MessageRichEditor = (props) => (React.createElement(TinyMCE, { ...props, inserterOptions: inserterOptions.map(({ label, value }) => ({ label, text: value })) }));
